import React, { useState } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import SuperAdminSidebar, { SuperAdminMobileHeader } from './SuperAdminSidebar';
import RenewalNotificationBell from './RenewalNotificationBell';
import ThemeToggle from '../UI/ThemeToggle';
import { useSuperAdmin } from '../../contexts/SuperAdminContext';
import { canAccessSuperAdminPage, getDefaultLandingPath } from '../../utils/superAdminAccess';
import './SuperAdminLayout.scss';

const SuperAdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isSuperAdmin, hasPermission } = useSuperAdmin();
  const location = useLocation();

  // Limited-access roles (support/billing) get bounced away from pages their
  // permissions don't unlock — mirrors what the sidebar already hides, so
  // typing a restricted URL directly doesn't bypass the panel scoping.
  if (!canAccessSuperAdminPage(location.pathname, { isSuperAdmin, hasPermission })) {
    return <Navigate to={getDefaultLandingPath({ isSuperAdmin, hasPermission })} replace />;
  }

  return (
    <div className="superadmin-layout">
      <SuperAdminMobileHeader onMenuClick={() => setSidebarOpen(true)} />
      <SuperAdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Renewal notifications — overdue renewal tasks escalated to managers.
          Floating bell, fixed top-right on desktop (hidden on mobile, where the
          bell is rendered inside the mobile header). */}
      <div className="hidden lg:block fixed top-5 right-5 z-40">
        <RenewalNotificationBell />
      </div>

      {/* Dark / light mode toggle — same floating button as the admin panel,
          fixed bottom-right on desktop; mobile has its own toggle in the header. */}
      <div className="hidden lg:block fixed bottom-5 right-5 z-40">
        <ThemeToggle />
      </div>

      <main className="superadmin-main">
        <div className="superadmin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SuperAdminLayout;